export function getFontName (Text:string): string {
  const RegExp = Text.match(/^\/Content\/fonts\/frontEndDev\/(.*)-[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}\.(otf|woff|ttf|woff2)$/)
  const fontName = RegExp ? RegExp[1].replace('-', ' ') : Text
  return fontName
}
